/**
 * Insumos: o vocabulário dos custos detalhados.
 *
 * As CATEGORIAS são poucas de propósito. O item é o detalhe (seringa de 5 mL,
 * meio de cultivo); a categoria é o que o Financeiro soma — "Repasse ·
 * Medicamentos" diz alguma coisa num gráfico, quarenta itens soltos não.
 */
export const CATEGORIAS_DE_INSUMO = [
  { id: 'medicamento',  rotulo: 'Hormônios e medicamentos' },
  { id: 'meio',         rotulo: 'Meios e reagentes' },
  { id: 'descartavel',  rotulo: 'Descartáveis' },
  { id: 'genetica',     rotulo: 'Genética' },
  { id: 'deslocamento', rotulo: 'Deslocamento' },
  { id: 'diaria',       rotulo: 'Diárias e equipe' },
  { id: 'outros',       rotulo: 'Outros' },
];

export const ROTULO_DA_CATEGORIA = Object.fromEntries(
  CATEGORIAS_DE_INSUMO.map(c => [c.id, c.rotulo]));

/**
 * Onde o custo aconteceu. As etapas da corrente, mais "geral" para o que é do
 * serviço inteiro — o deslocamento, a diária.
 *
 * DG30 e DG60 dividem "dg": o material de uma conferência é o da outra, e
 * separar só dobraria as linhas.
 */
export const ETAPAS_DE_CUSTO = [
  { id: 'protocolo', rotulo: 'Protocolo', requires: 'protocolo' },
  { id: 'opu',       rotulo: 'OPU',       requires: 'opu' },
  { id: 'fiv',       rotulo: 'FIV',       requires: 'fiv' },
  { id: 'te',        rotulo: 'TE',        requires: 'te' },
  { id: 'dg',        rotulo: 'DG',        requires: 'pregnancy_check' },
  { id: 'geral',     rotulo: 'Geral',     requires: null },
];

export const ROTULO_DA_ETAPA_DE_CUSTO = Object.fromEntries(
  ETAPAS_DE_CUSTO.map(e => [e.id, e.rotulo]));

export const UNIDADES = ['un', 'mL', 'L', 'dose', 'km', 'dia', 'cx', 'rolo', 'cilindro'];

/**
 * A lista que o laboratório importa com um clique, em vez de cadastrar do zero.
 *
 * SEM PREÇO. Preço de insumo muda com fornecedor, marca e cotação do mês; um
 * número sugerido aqui seria chute com cara de dado. Quem tem o preço preenche
 * no catálogo, quem não tem lança na hora no serviço.
 *
 * Montada a partir do que a rotina de OPU/FIV/TE usa: protocolo hormonal de
 * sincronização (implante de progesterona, estradiol, cloprostenol, eCG),
 * aspiração (agulha 18G/20G, meio de recuperação com heparina, tubo de 50 mL,
 * filtro), laboratório (meios de maturação, fecundação e cultivo sob óleo
 * mineral, Percoll, placas de 4 poços, gás, nitrogênio) e transferência
 * (bainha, camisa sanitária, palheta, lidocaína para a epidural).
 */
export const INSUMOS_SUGERIDOS = [
  // Protocolo
  { nome: 'Implante intravaginal de progesterona', unidade: 'un',   categoria: 'medicamento', etapa: 'protocolo' },
  { nome: 'Benzoato de estradiol',                 unidade: 'mL',   categoria: 'medicamento', etapa: 'protocolo' },
  { nome: 'Cipionato de estradiol',                unidade: 'mL',   categoria: 'medicamento', etapa: 'protocolo' },
  { nome: 'Cloprostenol (PGF2α)',                  unidade: 'mL',   categoria: 'medicamento', etapa: 'protocolo' },
  { nome: 'eCG',                                   unidade: 'dose', categoria: 'medicamento', etapa: 'protocolo' },
  { nome: 'GnRH (gonadorelina)',                   unidade: 'mL',   categoria: 'medicamento', etapa: 'protocolo' },
  { nome: 'FSH',                                   unidade: 'mL',   categoria: 'medicamento', etapa: 'protocolo' },
  { nome: 'Seringa descartável 5 mL',              unidade: 'un',   categoria: 'descartavel', etapa: 'protocolo' },
  { nome: 'Agulha descartável 40x12',              unidade: 'un',   categoria: 'descartavel', etapa: 'protocolo' },

  // OPU
  { nome: 'Meio de recuperação/lavagem OPU',       unidade: 'L',    categoria: 'meio',        etapa: 'opu' },
  { nome: 'Heparina sódica',                       unidade: 'mL',   categoria: 'medicamento', etapa: 'opu' },
  { nome: 'Ringer lactato / soro fisiológico',     unidade: 'L',    categoria: 'meio',        etapa: 'opu' },
  { nome: 'Agulha de aspiração OPU 18G/20G',       unidade: 'un',   categoria: 'descartavel', etapa: 'opu' },
  { nome: 'Tubo cônico 50 mL',                     unidade: 'un',   categoria: 'descartavel', etapa: 'opu' },
  { nome: 'Filtro coletor de oócitos',             unidade: 'un',   categoria: 'descartavel', etapa: 'opu' },
  { nome: 'Linha de aspiração (silicone)',         unidade: 'un',   categoria: 'descartavel', etapa: 'opu' },
  { nome: 'Placa de Petri 90 mm',                  unidade: 'un',   categoria: 'descartavel', etapa: 'opu' },
  { nome: 'Meio de transporte de oócitos',         unidade: 'mL',   categoria: 'meio',        etapa: 'opu' },
  { nome: 'Lidocaína 2%',                          unidade: 'mL',   categoria: 'medicamento', etapa: 'opu' },
  { nome: 'Álcool 70%',                            unidade: 'L',    categoria: 'descartavel', etapa: 'opu' },
  { nome: 'Papel toalha',                          unidade: 'rolo', categoria: 'descartavel', etapa: 'opu' },

  // FIV
  { nome: 'Meio de lavagem (HEPES)',               unidade: 'mL',   categoria: 'meio',        etapa: 'fiv' },
  { nome: 'Meio de maturação (MIV)',               unidade: 'mL',   categoria: 'meio',        etapa: 'fiv' },
  { nome: 'Meio de fecundação (FIV)',              unidade: 'mL',   categoria: 'meio',        etapa: 'fiv' },
  { nome: 'Meio de cultivo (SOF)',                 unidade: 'mL',   categoria: 'meio',        etapa: 'fiv' },
  { nome: 'Óleo mineral',                          unidade: 'mL',   categoria: 'meio',        etapa: 'fiv' },
  { nome: 'Percoll (gradiente)',                   unidade: 'mL',   categoria: 'meio',        etapa: 'fiv' },
  { nome: 'Placa de 4 poços',                      unidade: 'un',   categoria: 'descartavel', etapa: 'fiv' },
  { nome: 'Placa de Petri 35 mm',                  unidade: 'un',   categoria: 'descartavel', etapa: 'fiv' },
  { nome: 'Ponteira / pipeta',                     unidade: 'un',   categoria: 'descartavel', etapa: 'fiv' },
  { nome: 'Mistura gasosa (CO₂)',                  unidade: 'cilindro', categoria: 'meio',    etapa: 'fiv' },
  { nome: 'Nitrogênio líquido',                    unidade: 'L',    categoria: 'meio',        etapa: 'fiv' },
  { nome: 'Sêmen (dose)',                          unidade: 'dose', categoria: 'genetica',    etapa: 'fiv' },

  // TE
  { nome: 'Bainha de inovulação',                  unidade: 'un',   categoria: 'descartavel', etapa: 'te' },
  { nome: 'Camisa sanitária',                      unidade: 'un',   categoria: 'descartavel', etapa: 'te' },
  { nome: 'Palheta 0,25 mL',                       unidade: 'un',   categoria: 'descartavel', etapa: 'te' },
  { nome: 'Meio de manutenção de embriões',        unidade: 'mL',   categoria: 'meio',        etapa: 'te' },
  { nome: 'Embrião (compra)',                      unidade: 'un',   categoria: 'genetica',    etapa: 'te' },

  // DG e uso geral
  { nome: 'Luva de palpação',                      unidade: 'un',   categoria: 'descartavel', etapa: 'geral' },
  { nome: 'Gel para ultrassom',                    unidade: 'mL',   categoria: 'descartavel', etapa: 'dg' },
  { nome: 'Quilometragem',                         unidade: 'km',   categoria: 'deslocamento', etapa: 'geral' },
  { nome: 'Pedágio',                               unidade: 'un',   categoria: 'deslocamento', etapa: 'geral' },
  { nome: 'Alimentação / hospedagem',              unidade: 'un',   categoria: 'deslocamento', etapa: 'geral' },
  { nome: 'Diária de equipe',                      unidade: 'dia',  categoria: 'diaria',      etapa: 'geral' },
];
